import * as i18n from "../../i18n.ts";
import * as Html from "../../util/Html.ts";
import * as modal from "../../util/modal.ts";
import * as amplify from "../../util/amplify.ts";
import * as forms from "../../util/forms.js";

import ApiServer from "../../ApiServer.js";
import {getCache} from "../../server/objects/BudgetBeans.js";

Html.register({
  transactionaddmoreinfo:function(){
    this.parents('form').find('.moreinfo').show();
    this.fadeOut()
  }
})

function init(form){
  var 
    budgetTransactionType = form.find('[name=budgetTransactionType]'),
    categorySelect = form.find('select[name=budgetCategoryId]'),
    budgetpaidbylabel = form.find('.budgetpaidbylabel'),
    catSelectedId = {EXPENSE:categorySelect.attr('data-fw-select-value'),REVENUE:categorySelect.attr('data-fw-select-value')};
  /*
  form.find('[name=amount]').on('input',function(){
    this.style.width=((""+this.value).length*20+20)+'px'
  })
  */
  function updateUI(){
    var 
      currentType = budgetTransactionType.val(),
      categories = getCache().budgetCategoryCache.filtered().filter(cat=>cat.budgetTransactionType===currentType),
      defaultCat  = categories.find(cat=>cat.default);
    
    categorySelect.html(categories.map(cat=>'<option value="'+cat.metaId+'">'+Html.escape(cat.emoji+' '+cat.name)+'</option>').join('')+'<option value="add">⚙️ '+Html.escape(i18n.get('budget.actions.category'))+'</option>');
    budgetpaidbylabel.html(i18n.get(currentType==='EXPENSE'?'budget.label.paidby':'budget.label.receivedby'));
    
    if(!categories.find(cat=>cat.metaId===catSelectedId[currentType])){
      catSelectedId[currentType] = defaultCat.metaId;
    }
    categorySelect.val(catSelectedId[currentType])
  }
  categorySelect.on('change',(event)=>{
     var 
      currentType = budgetTransactionType.val();
    if(categorySelect.val()==='add'){
      categorySelect.val(catSelectedId[currentType]);
      Html.trigger(categorySelect,'budgetcategorymanage',[budgetTransactionType.val()])
    }else{
      catSelectedId[currentType] = categorySelect.val();
    }
  })
  updateUI();
  //radio must be enable
  setTimeout(function(){
    budgetTransactionType.on('change',updateUI);
  },1)
  amplify.subscribe('budgetRefreshed',updateUI);
  
  form.on('submit',function(event){
    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();
    
    if($(form.get(0).amount).amountValue()==0){
      forms.markInvalid($(form.get(0).amount),i18n.get('budget.transactionerrors.amount')).select()
      return;
    }
    
    var 
      metaId = form.get(0).metaId ? form.get(0).metaId.value:null;
      
    function doit(option){
      ApiServer.budgettransactionput.prepare(option)(form,function(){},function(err){
        if(err.code==='502' && err.message.indexOf('non-recurrent budget')>-1){
          modal.alert({title:'communication.justonemorething',message:"fw2.apierrors.502transactionrecurrencyend"},function(){
            $('*[data-widget="widget/form/recurrencyend"]').click()
          })
        }else{
          throw err;
        }
      })
    }
    if(metaId){
      ApiServer.budgettransactionupdateoption(form,function(options){
        if(options.length<2){
          doit(options[0])
        }else{
          modal.ask({
            title:'budget.updaterecurringtitle',
            message:'budget.updaterecurringtext',
            button:options.map(opt=>{return {value:opt,title:'budget.updaterecurring'+opt}})
          },function(opt){
            if(opt) doit(opt)
          });
        }
      })
    }else{
      doit(null);
    }
    
    
  })
  
}
Html.registerWidget('widget/form/budgetTransactionForm',{init:init})
